import React,{Component} from "react";

import PropTypes from "prop-types";
import {Dialog} from "../../../common/components/dialog"
import Checkbox from "../../../common/components/forms/checkbox";
import "../../style/add-to-album-dialog.scss"
import {
    clearAlbumItems,
    clearSelectedAlbumItems,
    deleteAlbumItems, downloadAlbumItems,
    favoriteAlbums, requestAddAlbumItemsToAlbum
} from "../../actions/album-item-actions";
import {
    disableAlbumItemSelectionMode,
    enableAlbumItemSelectionMode
} from "../../../settings/actions/application-actions";
import {
    albumCreated,
    albumCreationFailed,
    albumListRequested,
    requestAlbumCreation,
    requestAlbumUpdate
} from "../../actions/album-actions";
import connect from "react-redux/es/connect/connect";
import AlbumAddNew from "./album-add-new";
import {authorizedRequest} from "../../../common/request";

class AddToAlbumDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shouldDeleteInitialAlbum: false,
            isAddNewDialogOpen:false,
        }
        this.selectAlbum = this.selectAlbum.bind(this);
        this.fetchMoreAlbums = this.fetchMoreAlbums.bind(this);
        this.createAlbum = this.createAlbum.bind(this)
        this.addAlbum = this.addAlbum.bind(this);
    }
    selectAlbum(album){
        this.props.onAlbumSelected(album, this.state.shouldDeleteInitialAlbum);
    }
    componentDidMount() {
        this.fetchMoreAlbums();
    }

    fetchMoreAlbums(){
        if(this.props.albumList.offset != this.props.albumList.count || this.props.albumList.albums.length == 0){
            if(!this.props.amIfetching){
                console.log("Requesting albums offset " + this.props.albumList.offset);
                this.props.requestAlbumList(this.props.albumList.offset,this.props.amIfetching,50);
            }
            console.log("Setting timer to fetch more albums");
            setTimeout(()=> this.fetchMoreAlbums(), 1000);
        }
    }
    addAlbum(){
        this.setState({isAddNewDialogOpen:true,isProcessing:true})
    }
    createAlbum(title,description){
        authorizedRequest(
            `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs`,
            { title: title, description: description },
            'POST'
        )
            .then(album => {
                this.props.albumCreated(album)
                this.setState({isAddNewDialogOpen:false,isProcessing:false})
                setTimeout(()=>this.selectAlbum(album),100);

            })
            .catch((error) => {
                toast.warning("Failed to add content to new album")
                //dispatch(albumCreationFailed(error))
            });

    }
    render() {
        const {onClose, albums, isOpen} = this.props;
        const fullyFetchedAlbums = albums.filter(album => album.isLoaded === true);
        const isAllLoaded = fullyFetchedAlbums.length == albums.length;

        return <Dialog className="add-to-album-dialog" onClose={onClose} title="Add To Album" canCancel={true} isOpen={isOpen}>
            <React.Fragment>
                {this.props.showDeleteOriginal === true &&
                <React.Fragment>
                    <Checkbox onChange={(field) => this.setState({shouldDeleteInitialAlbum: field.value})}
                              name="shouldDeleteInitialAlbum"
                              value={this.state.shouldDeleteInitialAlbum}
                              label={this.props.deleteOriginalText || "Delete original album after adding?"}/>
                    < hr/>
                </React.Fragment>
                }
                <div className="new-album" onClick={this.addAlbum}>
                    <img src={require("../../../disc/images/new-disc.png")} width="50" height="50" alt="Add Album"/>
                    <span>New Album</span>
                </div>
                <div className="add-to-album-line"></div>

                <div className="add-to-album-list">
                    {!isAllLoaded && <div><i>Showing first {fullyFetchedAlbums.length} albums.  Fetching the other {albums.length - fullyFetchedAlbums.length} ones ...</i></div>}
                    {fullyFetchedAlbums.map(album => {
                        return <AlbumListItem key={album.id}
                                              onClick={() => this.selectAlbum(album)}
                                              album={album}/>

                    })}

                </div>
                {this.state.isAddNewDialogOpen &&
                <Dialog
                    isOpen={this.state.isAddNewDialogOpen}
                    onClose={()=>this.setState({isAddNewDialogOpen:false})}
                    title="Add New Album">
                    <AlbumAddNew createAlbumAction={this.createAlbum} onCancel={()=>this.setState({isAddNewDialogOpen:false})} />
                </Dialog>
                }
            </React.Fragment>

        </Dialog>

    }
}
const AlbumListItem = (props) => {
    const {album,onClick} = props;
    let imgSrc = require("../../../common/images/icon-missing-asset-grey.svg")
    if(album.thumbnails.length > 0){
        imgSrc = album.thumbnails[0]
    }
    return <div className="add-to-album-item" key={album.id} onClick={onClick}>
        <img width="60" src={imgSrc} alt="Album Thumb" className="add-to-album-item-thumbnail"/>
        <div className="add-to-album-item-description">
            <h3>{album.title}</h3>
            {album.stats.numPhotos} Photos, {album.stats.numClips} Videos
        </div>
    </div>
}

AddToAlbumDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    onAlbumSelected: PropTypes.func.isRequired,
    albums: PropTypes.array.isRequired,
    isOpen: PropTypes.bool.isRequired,
    showDeleteOriginal: PropTypes.bool,
    deleteOriginalText: PropTypes.string
};

const mapStateToProps = state => {
    return {
        albumItems: state.albumItems.albumItems,
        albumList: state.albumList,
        amIfetching: state.albumList.amIfetching,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        requestAlbumList: (offset = 0, amIfetching = false, max) => {
            dispatch(albumListRequested(dispatch, offset, true, max, false, amIfetching));
        },
        createAlbumAction: (title, description) => dispatch(requestAlbumCreation(dispatch, title, description)),
        requestAlbumUpdate: (id, updateData) => dispatch(requestAlbumUpdate(dispatch, id, updateData)),
        albumCreated: (album) => dispatch(albumCreated(album))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToAlbumDialog);




// WEBPACK FOOTER //
// ./src/album-view/components/dialog/add-to-album-dialog.jsx